/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { AUTH_SUCCESS, AUTH_FAILURE, AUTH_CLEAR } from 'actions/auth';

import { ADD_ROLE_SUCCESS, ADD_ROLE_REQUEST } from 'actions/admin';

import {
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_FAILURE,
  ADD_PICTURE_SUCCESS,
  MAKE_DEFAULT_PICTURE_SUCCESS,
  DELETE_PICTURE_SUCCESS,
  REQUEST_CODE_SUCCESS,
  VERIFY_CODE_SUCCESS,
  RESET_CODE_SUCCESS,
  REORDER_PICTURES_SUCCESS,
} from 'actions/user';

import {
  REGISTER_COMPANY_SUCCESS,
  UPDATE_COMPANY_SUCCESS,
} from 'actions/company';

import {
  REGISTER_FREELANCE_SUCCESS,
  REGISTER_FREELANCE_COMPANY_SUCCESS,
  UPDATE_FREELANCE_COMPANY_SUCCESS,
} from 'actions/paymentMethod';

/**
 * User authentification status model.
 *
 * @type {object} SIGNUP_STATUS
 * @type {('ENTER_PHONE_NUMBER'|'ENTER_VALIDATION_CODE'|'FILL_IN_CLIENT_VAT'|'FILL_IN_CLIENT_COMPANY'|'FILL_IN_PROFILE'|'APPLICATION_PENDING'|'APPLICATION_REJECTED'|'APPLICATION_APPROVED')} status.signup_status
 */
export const SIGNUP_STATUS = {
  ENTER_PHONE_NUMBER: 'ENTER_PHONE_NUMBER',
  ENTER_VALIDATION_CODE: 'ENTER_VALIDATION_CODE',
  FILL_IN_CLIENT_VAT: 'FILL_IN_CLIENT_VAT',
  FILL_IN_CLIENT_COMPANY: 'FILL_IN_CLIENT_COMPANY',
  FILL_IN_PROFILE: 'FILL_IN_PROFILE',
  FILL_IN_PORTFOLIO: 'FILL_IN_PORTFOLIO',
  APPLICATION_PENDING: 'APPLICATION_PENDING',
  APPLICATION_REJECTED: 'APPLICATION_REJECTED',
  APPLICATION_APPROVED: 'APPLICATION_APPROVED',
};

const initialState = {
  status: null,
  type: '', // @NOTE Do we need this here?
};

/**
 * This is the user reducer. It listens for actions and updates the user object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case ADD_PICTURE_SUCCESS:
    case MAKE_DEFAULT_PICTURE_SUCCESS:
    case DELETE_PICTURE_SUCCESS:
    case REGISTER_COMPANY_SUCCESS:
    case UPDATE_COMPANY_SUCCESS:
    case REQUEST_CODE_SUCCESS:
    case VERIFY_CODE_SUCCESS:
    case RESET_CODE_SUCCESS:
    case REGISTER_FREELANCE_SUCCESS:
    case REGISTER_FREELANCE_COMPANY_SUCCESS:
    case UPDATE_FREELANCE_COMPANY_SUCCESS:
    case REORDER_PICTURES_SUCCESS:
      return {
        ...state,
        ...payload.profile,
        show_admin: payload.show_admin || false,
        show_dev: payload.show_dev || false,
        show_edit_mode: payload.show_edit_mode || false,
        can_apply_for_jobs: payload.can_apply_for_jobs || false,
        can_search_jobs: payload.can_search_jobs || false,
        can_post_jobs: payload.can_post_jobs || false,
        can_search_talents: payload.can_search_talents || false,
        company: payload.company || {},
        has_new_inbox_content: payload.has_new_inbox_content || false,
        has_payment_method: payload.has_payment_method || false,
        payment_method_label: payload.payment_method_label || '',
        notifications: payload.notifications || [],
        status: SIGNUP_STATUS[payload.signup_status],
        type: payload.signup_as,
        loading: false,
      };

    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        ...payload, // We get the user profile back and update.
        loading: false,
      };

    case UPDATE_PROFILE_REQUEST:
    case ADD_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case AUTH_FAILURE:
    case AUTH_CLEAR:
      return initialState;

    default:
      return state;
  }
}
